import React from 'react';
import Layout from '../../components/Layout/Layout';
import ViewBooking from './ViewBooking';
import GuestCartReplay from './GuestCartReplay';
import SubNavBar from '../../components/SubNavBar/SubNavBar';

async function action({ params, store, query, pathname }) {
    const title = store.getState().siteSettings?.data?.siteTitle
    const description = store.getState().siteSettings?.data?.metaDescription;

    let isAuthenticated = store.getState().runtime.isAuthenticated;

    // Guest-fill replay (app parity): a logged-out visitor who filled the cart and hit "Review Your
    // Request" was sent through login with return=/order/replay. Now authenticated, take the stashed
    // guest cart and create the REAL order server-side (addOrderAction -> /order/:id). The auth wall on
    // addOrderWhole/createUserBooking is unchanged — order creation still happens only for a logged-in
    // user; this only moves the single login step out of the middle of the funnel.
    if (isAuthenticated && params?.id === 'replay') {
        return {
            title,
            description,
            component: (
                <Layout isBottomBanner={true}>
                    <div className={"subPageMainContainer"}>
                        <SubNavBar />
                        <GuestCartReplay />
                    </div>
                </Layout>
            ),
        };
    }

    if (!isAuthenticated) {
        // Don't dump the user to home on an auth-expired / not-logged-in hit. Send them to the home
        // login modal carrying the intended path (?login=1&return=<path>); the header opens the login
        // modal and stashes referUrl, so finishing login lands them back on /order/:id (not home).
        // Mirrors the existing referUrl mechanism (CategorySearch -> setRuntimeVariable referUrl).
        const returnPath = pathname || `/order/${params?.id ?? ''}`;
        return { redirect: '/?login=1&return=' + encodeURIComponent(returnPath) }
    }

    return {
        title,
        description,
        component: (
            <Layout isBottomBanner={true}>
                <div className={isAuthenticated ? "subPageMainContainer" : "withoutPageMainContainer"}>
                    {isAuthenticated && <SubNavBar />}
                    <ViewBooking />
                </div>
            </Layout>
        ),
    };
}

export default action;